import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { messages } from '../messages';
import FeedbackCollector from '../../feedback-collector/feedback-collector';
import { Box, xcss } from '@atlaskit/primitives';
import { BetaTag, FeedbackButton } from '@atlassian/search-common';
import { fg } from '@atlaskit/platform-feature-flags';
var footerContainerStyles = xcss({
  padding: 'space.200',
  borderTop: '1px solid',
  borderColor: 'color.border',
  display: 'flex',
  alignItems: 'center',
  color: 'color.text',
  gap: 'space.150'
});
export var FeedbackFooter = function FeedbackFooter() {
  return /*#__PURE__*/React.createElement(Box, {
    xcss: footerContainerStyles
  }, !fg('rovo_beta_tag_removal') && /*#__PURE__*/React.createElement(BetaTag, null), /*#__PURE__*/React.createElement(FormattedMessage, messages.quick_find_footer_text), /*#__PURE__*/React.createElement(FeedbackCollector, {
    TriggerComponent: function TriggerComponent(_ref) {
      var onClick = _ref.onClick;
      return /*#__PURE__*/React.createElement(FeedbackButton, {
        onClick: onClick
      });
    }
  }));
};